import { Capacitor } from '@capacitor/core';
import { FacebookLogin } from '@capacitor-community/facebook-login';

export const isFacebookSDKLoaded = () => {
    if (Capacitor.isNativePlatform()) return true;
    return typeof window !== 'undefined' && typeof window.FB !== 'undefined' && typeof window.FB.init === 'function';
};

export const isFacebookUserLogedIn = async () => {
    if (Capacitor.isNativePlatform()) {
        const result = await FacebookLogin.getCurrentAccessToken();
        return !!result.accessToken;
    }
    return window.FB.getAuthResponse();
};

export const loginWithFacebookSdk = async (callback, config_id, scope = null) => {
    if (Capacitor.isNativePlatform()) {
        try {
            const loginOptions = scope ? {
                permissions: scope.split(',').map(s => s.trim())
            } : {
                // For Business Login (config_id) on native, we pass it to the plugin.
                // Note: Ensure your version of the capacitor-facebook-login plugin supports configId.
                configId: config_id,
                permissions: [] // Business Login usually handles permissions via the config
            };

            const result = await FacebookLogin.login(loginOptions);
            if (result.accessToken) {
                callback({
                    authResponse: {
                        accessToken: result.accessToken.token,
                        userID: result.accessToken.userId,
                    },
                    status: 'connected'
                });
            } else {
                callback({ status: 'unknown' });
            }
        } catch (e) {
            console.error('Capacitor Facebook Login failed', e);
            callback({ error: 'login_failed', details: e?.message });
        }
        return;
    }

    if (!isFacebookSDKLoaded()) {
        console.warn('Facebook SDK not loaded yet');
        callback({ error: 'sdk_not_loaded' });
        return;
    }
    try {
        window.FB.login((response) => {
            callback(response);
        }, scope ? {
            scope,
            return_scopes: true,
        } : {
            config_id,
            return_scopes: true,
        });
    } catch (e) {
        console.error('FB.login threw', e);
        callback({ error: 'login_failed', details: e?.message });
    }
};

export const checkLoginStatus = async (onUserConnected, onUserDisconnected = () => { }) => {
    if (Capacitor.isNativePlatform()) {
        const result = await FacebookLogin.getCurrentAccessToken();
        if (result.accessToken) {
            onUserConnected(result.accessToken.token);
        } else {
            onUserDisconnected();
        }
        return;
    }

    window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
            onUserConnected(response.authResponse.accessToken);
        } else {
            onUserDisconnected();
        }
    });
};

export const fbLogout = async () => {
    if (Capacitor.isNativePlatform()) {
        await FacebookLogin.logout();
        return true;
    }

    return new Promise((resolve, reject) => {
        try {

            const accessToken = window.FB.getAccessToken();
            if (!accessToken) {
                resolve(false);
                return;
            }

            window.FB.logout((response) => {
                if (response.status === 'connected') {
                    reject(new Error('Facebook logout failed'));
                } else {
                    resolve(true);
                }
            });
        } catch (error) {
            console.error('Facebook logout error:', error.message);
            reject(error);
        }
    });
};